import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
export const effectiveQueryUrl = "views/search/effective_query";
const EFFECTIVE_QUERY_QUERY_ID = "effective-query";
const EFFECTIVE_QUERY_SEARCH_TYPE_ID = "effective-query-message-list";
const EFFECTIVE_QUERY_KEY = "effective_query";
const toRequestFilters = (selectedFilters) => selectedFilters.toList().map(({ frontendId, ...filter }) => filter).toArray();
const fetchEffectiveQuery = (queryString, selectedFilters) => fetch("POST", qualifyUrl(effectiveQueryUrl), {
  query_string: queryString,
  filters: toRequestFilters(selectedFilters)
}).then(
  (response) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = response.search.queries[EFFECTIVE_QUERY_QUERY_ID]) == null ? void 0 : _a.search_types[EFFECTIVE_QUERY_SEARCH_TYPE_ID]) == null ? void 0 : _b.effective_query) != null ? _c : "";
  }
);
const useEffectiveQuery = (queryString, selectedFilters) => {
  const { data, isFetching } = useQuery({
    queryKey: [EFFECTIVE_QUERY_KEY, queryString, toRequestFilters(selectedFilters)],
    queryFn: () => defaultOnError(
      fetchEffectiveQuery(queryString, selectedFilters),
      "Loading the effective query failed with status",
      "Could not load the effective query"
    ),
    initialData: ""
  });
  return { effectiveQuery: data, isFetching };
};
export default useEffectiveQuery;
